<template>
    <div class="venue-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item><i class="el-icon-office-building"></i>展馆列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>展馆信息管理</span>
                </div>
                <div class="header-actions">
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addData">
                        新增展馆
                    </el-button>
                    <el-button size="mini" icon="el-icon-s-grid" @click="goCategory">
                        分类管理
                    </el-button>
                </div>
            </div>

            <!-- 搜索区域 -->
            <div class="search-container">
                <el-form
                        :inline="true"
                        :model="searchForm"
                        ref="searchForRef"
                        label-width="80px"
                        size="mini"
                        class="search-form"
                >
                    <el-form-item label="所属省市">
                        <el-cascader
                                ref="cascaderAddr"
                                style="width: 90%"
                                v-model="areaList"
                                clearable
                                filterable
                                :props="propsdata"
                                :key="isResouceone"
                                @change="handleChangeAddress"
                                placeholder="请选择省市"
                        >
                        </el-cascader>
                    </el-form-item>

                    <el-form-item label="展馆名称">
                        <el-input
                                v-model="searchForm.name"
                                placeholder="请输入展馆名称"
                                clearable
                                prefix-icon="el-icon-search"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="展馆状态">
                        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="营业中" value="1"></el-option>
                            <el-option label="已关闭" value="2"></el-option>
                            <el-option label="维护中" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="面积范围">
                        <el-select v-model="searchForm.areaRange" placeholder="请选择面积" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="1000㎡以下" value="1"></el-option>
                            <el-option label="1000-5000㎡" value="2"></el-option>
                            <el-option label="5000-10000㎡" value="3"></el-option>
                            <el-option label="10000㎡以上" value="4"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button size="mini" type="primary" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 数据表格 -->
            <div class="table-container">
                <el-table
                        ref="multipleTable"
                        :data="tableLoadData"
                        stripe
                        border
                        size="mini"
                        v-loading="loading"
                        element-loading-text="数据加载中..."
                        element-loading-spinner="el-icon-loading"
                        :empty-text="emptyText"
                        style="width: 100%"
                >
                    <el-table-column type="index" label="序号" width="70" align="center">
                        <template slot-scope="scope">
                            <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展馆名称"
                            width="300"
                            prop="title"
                            :show-overflow-tooltip='true'
                    >
<!--                        <template slot-scope="scope">-->
<!--                            <div class="venue-name-cell">-->
<!--                                <div class="venue-name">{{ scope.row.title }}</div>-->
<!--                                <div class="venue-address" v-if="scope.row.address">-->
<!--                                    <i class="el-icon-location"></i>-->
<!--                                    {{ scope.row.address }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </template>-->
                    </el-table-column>

                    <el-table-column
                            label="展馆状态"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag
                                    v-if="scope.row.status === 1"
                                    size="mini"
                                    type="success"
                                    effect="dark"
                            >营业中</el-tag>
                            <el-tag
                                    v-else-if="scope.row.status === 2"
                                    size="mini"
                                    type="info"
                                    effect="dark"
                            >已关闭</el-tag>
                            <el-tag
                                    v-else
                                    size="mini"
                                    type="warning"
                                    effect="dark"
                            >维护中</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展馆面积"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.area">{{ scope.row.area }}㎡</span>
                            <span v-else class="empty-text">-</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="容纳人数"
                            width="120"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.capacity">{{ scope.row.capacity }}人</span>
                            <span v-else class="empty-text">-</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="所属分类"
                            width="150"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag size="mini" type="primary" v-if="scope.row.category">
                                {{ scope.row.category.name }}
                            </el-tag>
                            <span v-else class="empty-text">未分类</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="所属商家"
                            width="150"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.shop">{{ scope.row.shop.name }}</span>
                            <span v-else class="empty-text">未指定</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="添加日期"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.add_time | dateFormat }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="操作"
                            width="180"
                            fixed="right"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="action-buttons">
                                <el-button
                                        type="text"
                                        icon="el-icon-edit"
                                        size="mini"
                                        @click="handleClick(scope.row)"
                                        plain
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="del(scope.row)"
                                        plain
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                >
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import moment from 'moment'
    import axios from "axios";

    export default {
        name: "VenueList",
        components: {},
        props: {},
        data() {
            return {
                areaList:[],
                isResouceone: false,
                propsdata: {
                    checkStrictly: true,
                    lazy: true,
                    lazyLoad(node, resolve) {
                        console.log(node)
                        let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
                        setTimeout(() => {
                            if (node.level == 0) {
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:1
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                            if (node.level == 1) {
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:node.value
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                            if (node.level == 2) {
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:node.value
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                            leaf: true,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                        }, 100);
                    },
                },
                // 搜索表单
                searchForm: {
                    name: "",
                    shop_id:'',
                    keyword:'',
                    province_id:'',
                    city_id:'',
                    district_id:'',
                    status:'',
                    areaRange: ''
                },
                // 表格数据
                tableLoadData: [],
                loading: false,
                emptyText: "暂无数据",

                // 分页
                pageNum: 1,
                pageSize: 10,
                total: 0,

                showType: '',
            };
        },
        created() {
            this.showType = this.$route.query.showType;
            this.DataList();
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "";
                return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        methods: {
            // 处理地区选择变化
            handleChangeAddress(value) {
                if (value && value.length > 0) {
                    // 根据选择的地区级别设置对应的ID
                    if (value.length >= 1) {
                        this.searchForm.province_id = value[0];
                    }
                    if (value.length >= 2) {
                        this.searchForm.city_id = value[1];
                    }
                    if (value.length >= 3) {
                        this.searchForm.district_id = value[2];
                    }
                } else {
                    // 清空地区选择
                    this.searchForm.province_id = '';
                    this.searchForm.city_id = '';
                    this.searchForm.district_id = '';
                }
            },

            // 跳转到编辑页面
            handleClick(row) {
                this.$router.push('/venueForm?id=' + row.id)
            },

            // 跳转到分类管理
            goCategory() {
                this.$router.push('/venueCategory')
            },

            // 获取展馆列表
            DataList() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    showType: this.showType,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    parent_id: sessionStorage.getItem('shop_id'),
                    title: this.searchForm.name,
                    status: this.searchForm.status,
                    province_id: this.searchForm.province_id,
                    city_id: this.searchForm.city_id,
                    district_id: this.searchForm.district_id,
                    areaRange: this.searchForm.areaRange
                }

                // 这里需要替换为实际的展馆列表接口
                this.$axios.findVenueListP(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.tableLoadData = res.data.data || [];
                        this.total = res.data.total || 0;

                        // 如果没有数据，显示提示信息
                        if (this.tableLoadData.length === 0) {
                            this.emptyText = "暂无展馆数据";
                        }
                    } else {
                        this.$message.error(res.msg || "获取数据失败");
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error("网络错误，请稍后重试");
                })
            },

            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize;
                this.pageNum = 1;
                this.DataList();
            },

            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage;
                this.DataList();
            },

            // 新增展馆
            addData() {
                this.$router.push({name:'venueForm'});
            },

            // 搜索
            searchSubmit() {
                this.pageNum = 1;
                this.DataList();
            },

            // 重置搜索
            resetSearch() {
                this.searchForm = {
                    name: "",
                    status: "",
                    areaRange: ""
                };
                this.areaList = [];
                this.pageNum = 1;
                this.DataList();
            },

            // 删除展馆
            del(e) {
                this.$confirm('确定要删除该展馆吗？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id: sessionStorage.getItem('company_id'),
                        access_token: sessionStorage.getItem('token'),
                        id: e.id,
                    }

                    // 这里需要替换为实际的展馆删除接口
                    this.$axios.venueDel(param).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.pageNum = 1;
                            this.DataList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        this.$message.error("删除失败，请稍后重试");
                    });
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            }
        }
    };
</script>

<style scoped>
    .venue-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .search-container {
        margin-bottom: 20px;
    }

    .search-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .table-container {
        margin-bottom: 20px;
    }

    .venue-name-cell {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .venue-name {
        font-weight: 500;
        margin-bottom: 4px;
    }

    .venue-address {
        font-size: 12px;
        color: #909399;
        display: flex;
        align-items: center;
    }

    .venue-address i {
        margin-right: 4px;
    }

    .empty-text {
        color: #909399;
        font-style: italic;
    }

    .action-buttons {
        display: flex;
        justify-content: center;
        gap: 8px;
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .venue-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .search-form {
            flex-direction: column;
            align-items: flex-start;
        }

        .search-form .el-form-item {
            margin-right: 0;
            margin-bottom: 10px;
            width: 100%;
        }

        .action-buttons {
            flex-direction: column;
            gap: 5px;
        }

        .action-buttons .el-button {
            width: 100%;
        }
    }
</style>
